import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';

import Form from './Form';

// import { useContext } from '../Context';

export default function ModalForm({ show, onHide }) {
  // const { dispatch, actions, state } = useContext();

  return (
    <Modal
      className="student inmodal auto without-overflow"
      show={show}
      onHide={onHide}
    >
      <Modal.Header closeButton>
        <Modal.Title>Create an Affiliate</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onHide={onHide} />
      </Modal.Body>
    </Modal>
  );
}

ModalForm.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
};
